import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useLocale } from 'hooks/useLocale';
import { StaleTime } from 'queries/types';

import { lineupsQuery } from './queries';

/**
 * What lineup an event runs: XP programs, a standard lineup, or neither.
 * Not the legacy `xp_program` relation, which no longer says whether it runs XP.
 */
export const useLineups = () => {
  const { query } = useRouter();
  const { locale } = useLocale();

  const reactQuery = useQuery({
    ...lineupsQuery({ locale, slug: `${query.slug}` }),
    staleTime: StaleTime.FOREVER,
  });

  return {
    programs: reactQuery.data?.pageEvent?.programs,
    lineups: reactQuery.data?.pageEvent?.lineups,
    isLoading: reactQuery.isLoading,
  };
};
